<template>
    <el-card
        class="stats-box-card"
        shadow="hover"
    >
        <div class="stats-box-card__title">
            Ссылка на регистрацию
        </div>
        <a
            :href="registrationLinkHref"
            target="_blank"
        >{{ registrationLinkHref }}</a>
    </el-card>
</template>

<script>
export default {
    name: 'RegistrationLink',

    props: {
        eventId: {
            type: String,
            default: null
        }
    },

    computed: {
        registrationLinkHref() {
            return location.origin + '/lk';
        }
    }
};
</script>

<style scoped>
.stats-box-card__title {
    white-space: nowrap;
}
</style>
